import { connect } from "react-redux";
import Component from "./MyOrganisation";

export default connect(
    null,
    ({ alert: { silence } }) => ({ silence })
)(Component);

